// Exposes DOM window.
// If mocked, it allows unit testing for window-dependent modules out of
// DOM context.

const DOMWindow = window;
export { DOMWindow as window };
